import React from 'react';
import _get from 'lodash/get';
import { WebsiteComponentInteractionPropType } from '../../../../../../../../services/proptypes';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../../../../../analytics/components/Event';
import WebsiteComponentInteraction from '../../../../../../../interactions/components/WebsiteComponentInteraction';
var defaultProps = {};
function Interaction(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
    interaction: element,
    event: {
      category: EVENT_CATEGORIES.HERO_EVENT_CATEGORY,
      action: EVENT_ACTIONS.HERO_INTERACTION_ACTION,
      label: _get(element, 'label', ''),
      value: _get(element, 'url', '')
    }
  });
}
Interaction.defaultProps = defaultProps;
export default Interaction;